import { KnmAddressTypeCodesEnum } from 'APIPackage/CatalogsModule/enums/KnmAddressTypeCodesEnum';
import { IKnmErpFormObject } from 'KnmErpPackage/KnmErpSubjectModule/interfaces/IKnmErpFormObject';

export const checkObjectAddressMatchFns = (formObject: IKnmErpFormObject, registryLegalAddressFns: string) =>
  formObject.addressType?.code === KnmAddressTypeCodesEnum.TYPE_I && formObject.address !== registryLegalAddressFns;
